<template>
  <div>
    <div class="d-flex justify-space-between mb-4">
      <div>
        <div class="page-title mb-2">ฐานข้อมูลประวัติผู้ใช้บริการ</div>
      </div>

      <div class="d-flex flex-column gap-12">
        <div class="d-flex gap-12">
          <div>
            <v-btn
              min-width="134"
              height="35"
              color="#5CB844"
              style="border-radius: 25px"
              depressed
              dark
              @click="exportToExcel()"
            >
              <Iconify icon="file-icons:microsoft-excel" class="font-18" color="white" />
              <span class="ml-2 font-14 font-w-700">Export Excel</span>
            </v-btn>
          </div>
          <div style="max-width: 250px">
            <TextField
              hide-details
              placeholder="ค้นหา"
              append-icon="ic:baseline-search"
              @onChange="keyword = $event"
              @onEnter="getData()"
            ></TextField>
          </div>
        </div>
      </div>
    
    </div>
    <div>
        <div class="d-flex flex-column gap-12">
        <div class="d-flex font-type-bold gap-12 align-center">
            <div class="mr-5">
                ประเภทผู้ใช้บริการ
            </div>
          <SelectBox
            style="max-width:720px;"
            placeholder="เลือกประเภท"
            hide-details
            clearable
            :items="customerTypeList"
            item-text="name"
            item-value="name"
            @onChange="
              customer_type = $event;
              getData();
            "
          ></SelectBox>
        </div>
      </div>
    </div>
    <div class='mt-10 d-flex align-center justify-space-between'>   
        <div class="d-flex align-center">
        <Iconify
          icon="bxs:message-square-detail"
          color="var(--theme-color-seven)"
          class="mr-3"
        ></Iconify>
      <div class="font-type-bold font-20">แบบฟอร์มผู้ใช้บริการทั้งหมด</div>
      </div>
      <!-- <div>
        <div class="d-flex justify-end">
        <Button @onClick="addUser"  
        theme="1"
        >+ เพิ่มผู้ใช้บริการ </Button>
      </div>
      </div> -->
    </div>
    <divcard  class='mt-10'>
            <table class="custom-table ">
        <thead>
          <tr>
            <th class="text-center" width="5%">จัดการ</th>
            <th class="text-center" width="12%">รหัสลูกค้า</th>
            <th class="text-center" width="18%">ชื่อ-สกุล</th>
            <th class="text-center" width="25%">ที่อยู่</th>
            <th class="text-center" width="15%">ประเภทผู้ใช้งาน</th>
            <th class="text-center" width="15%">แผนงาน</th>
            <th class="text-center" width="10%">สถานะ</th>
          </tr>
        </thead>
        <tbody v-if="customers && customers.length > 0">
          <tr v-for="(user, index) in customers" :key="index">
            <td class="d-flex justify-space-between align-center gap-6">
                <v-btn 
                    small
                    icon
                    class="edit-icon-class"
                    @click="onEdit(user.id)"
                  >
                    <Iconify icon="material-symbols:edit" color="black" size="18px"></Iconify>
                </v-btn>
                <v-btn 
                    small
                    icon
                    class="edit-icon-class"
                    @click="onView(user.id)"
                  >
                    <Iconify icon="material-symbols:visibility" color="black" size="18px"></Iconify>
                </v-btn>

            </td>
            <td class="text-center">{{ user.customer_no }}</td>
            <td class="text-center">
              <span >{{ user.name }}</span>
            </td>
            <td class="text-center ellipsis">
              <v-tooltip bottom color="#464647" dark>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on" class="ellipsis">
                            {{ (user?.address ?? "") + " " + (user?.district ?? "") + " " + (user?.sub_district ?? "") + " " + (user?.province ?? "") }}
                          </span>
                        </template>
                        <div class="font-14 text-center">
                          {{ (user?.address ?? "") + " " + (user?.district ?? "") + " " + (user?.sub_district ?? "") + " " + (user?.province ?? "") }}
                        </div>
                      </v-tooltip>
            </td>
            <td class="text-center">{{ user.customer_type }}</td>
            <td class="text-center">{{ user?.plan_latest_history?.plan ?? "-" }}</td>
            <td class="text-center">{{ user.status === 1 ? "ใช้งาน" : "ปิดใช้งาน" }}</td>
          </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td class="text-center" colspan="7">ไม่มีข้อมูล</td>
        </tr>
      </tbody>
      </table>
    </divcard>
    <div class='mt-5 d-flex justify-end mb-10'>
        <v-pagination
          v-model="paginate.current_page"
          :length="paginate.last_page"
          color="#DE7033"
          :total-visible="7"
          @input="getData"
        ></v-pagination>
    </div>
  </div>
</template>

<script>
import TextField from "../../components/input/TextField.vue";
import SelectBox from "@/components/input/SelectBox";
import Button from "@/components/input/Button";
import * as XLSX from "xlsx";

export default {
  name: "UserServiceHistory",
  components: { 
    TextField,
    Button,
    SelectBox
},
  data() {
    return {
      keyword: "",
      status: "",
      customers: [
      ],
      paginate: {
        total: 1,
        per_page: 1,
        current_page: 1,
        last_page: 1,
      },
      customerTypeList:[],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData(page) {
        const payload = {
            page: page || this.paginate.current_page,
            keyword: this.keyword,
            customer_type: this.customer_type,
        };
      let res = await this.$apiFire("UserServiceHistory/index", payload);
      console.log('res',res)
      if(res.data){
        this.customers = res.data?.customers?.data ?? [];
        this.customerTypeList = res.data?.customer_types ?? [];
        this.paginate = {
            total: res.data?.customers?.total,
            per_page: res.data?.customers?.per_page,
            current_page: res.data?.customers?.current_page,
            last_page: res.data?.customers?.last_page,
        };
      }
    },
    addUser(){
        this.$router.push({
            name:'UserServiceHistoryCreate'
        })
    },
    onView(id){
        this.$router.push({
            name:'UserServiceHistoryId',
            params:{
                id:id
            }
        })
    },
    onEdit (id) {
      this.$router.push({
        name: "UserServiceHistoryEdit",
        params: { id: id },
      });
    },
    exportToExcel() {
      if (!this.customers || this.customers.length === 0) {
        this.$store.commit("General/setModal", {
          title: "ไม่มีข้อมูลให้ Export",
          text: "กรุณาตรวจสอบข้อมูลในตารางก่อนทำการ Export",
          theme: "warning",
          showCancel: false,
        });
        return;
      }

      let data = [];
      this.customers.forEach((customer, i) => {
        data.push({
          ลำดับ: i + 1,
          "รหัสลูกค้า": customer.customer_no,
          "ชื่อ-สกุล": customer.name,
          "ที่อยู่": (customer?.address ?? "") + " " + (customer?.district ?? "") + " " + (customer?.sub_district ?? "") + " " + (customer?.province ?? ""),
          "ประเภทผู้ใช้งาน": customer.customer_type,
          "แผนงาน": customer?.plan_latest_history?.plan ?? "-",
          "สถานะ": customer.status === 1 ? "ใช้งาน" : "ปิดใช้งาน",
        });
      });

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");

      let doc_date = this.$moment().add(543, "year").format("DDMMYYYY");
      let fileName = `user_service_history_${doc_date}.xlsx`;
      XLSX.writeFile(workbook, fileName);
    },
  },
};
</script>

<style scoped lang="scss">
.custom-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;

  th,
  td {
    border: 1px solid var(--theme-color-nine);
    padding: 10px;
  }

  th {
    background-color: #ffffff;
    text-align: center;
    font-weight: bold;
  }

  .text-center {
    text-align: center;
  }
.ellipsis {
  white-space: nowrap;
  overflow: hidden;   
  text-overflow: ellipsis; 
  max-width: 200px;   
}
 
}
</style>

